var map = {
	"./sAGlPickup.png": "75f0",
	"./sAKPickup.png": "7818",
	"./sAShotgunPickup.png": "af1c",
	"./sBPistolPickup.png": "1964",
	"./sBussPickup.png": "591d",
	"./sCustomPickup.png": "4333",
	"./sCustomPickupLarge.png": "6d5e2",
	"./sCustomPickupLargeDark.png": "bcbb",
	"./sGlPickup.png": "fa5f",
	"./sGrenadePickup.png": "34ca",
	"./sHammerPickup.png": "e31a",
	"./sKnifePickup.png": "9534",
	"./sLastBPickup.png": "0155",
	"./sM16Pickup.png": "81af",
	"./sMinePickup.png": "23bb",
	"./sMine_1Pickup.png": "9e0a",
	"./sP90Pickup.png": "aa14",
	"./sPPistolPickup.png": "a26f",
	"./sPShotgunPickup.png": "1f93",
	"./sPistolBigPickup.png": "d9df",
	"./sPistolPickup.png": "a088",
	"./sPlasmaPickup.png": "a70c",
	"./sPunchPickup.png": "c676",
	"./sPunchPickupDark.png": "d239",
	"./sRevolver1Pickup.png": "f687",
	"./sRevolver2Pickup.png": "6b43",
	"./sRevolver3Pickup.png": "3e00",
	"./sRevolverPickup.png": "d2f5",
	"./sRiflePickup.png": "97fa",
	"./sSPistolPickup.png": "8ca1",
	"./sSShotgunPickup.png": "11f4",
	"./sSawedPickup.png": "0a39",
	"./sScythePickup.png": "2636",
	"./sScytheSmallPickup.png": "23c1",
	"./sShuriPickup.png": "bf58",
	"./sSicklePickup.png": "2a49",
	"./sSledgePickup.png": "6ce3",
	"./sSubPickup.png": "d4d6",
	"./sTKPistolPickup.png": "2a73",
	"./sTommyPickup.png": "18a7",
	"./sUziPickup.png": "1b3c",
	"./sXbowPickup.png": "6cd6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bdd9";